import { createSlice } from '@reduxjs/toolkit';
import { getEnquries } from '../thunks/enquiryThunk';

const initialState = {
  list: [],
  total: 0,
  loading: false,
  error: null,
};

const enquirySlice = createSlice({
  name: 'enquiry',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEnquries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEnquries.fulfilled, (state, action) => {
        state.list = action.payload.data;
        state.total = action.payload.total;
        state.loading = false;
      })
      .addCase(getEnquries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default enquirySlice.reducer;